import React, { useEffect, useState } from "react";
import axios from "axios";
import ProductCard from "../components/ProductCard";
import { Link } from "react-router-dom";
import API_URL from "../config";
//import cloudinary from '../cloudinary-config/cloudinary.js'; 

export default function NewArrivals() {
  const [products, setProducts] = useState([]);
  const [loading,  setLoading]  = useState(true);

  useEffect(() => {
    axios.get(`${API_URL}/api/products`)
      .then(res => {
        const newOnes = res.data.filter(p => p.isNewArrival);
        setProducts(newOnes.length > 0 ? newOnes : res.data.slice(0, 8));
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;1,400&family=DM+Sans:wght@300;400;500&display=swap');
        .na-root*,.na-root *::before,.na-root *::after{box-sizing:border-box;margin:0;padding:0}
        .na-root{font-family:'DM Sans',sans-serif;background:#fdf9f6;min-height:80vh}

        /* ── HERO ── */
        .na-hero{
          background:#1a1410;
          padding: 36px 32px 28px;
          text-align:center;
          position:relative;
          overflow:hidden;
        }
        .na-hero::before{
          content:'NEW';
          position:absolute;
          top:50%;left:50%;
          transform:translate(-50%,-50%);
          font-family:'Cormorant Garamond',serif;
          font-size:clamp(50px,10vw,120px);
          font-weight:300;
          color:transparent;
          -webkit-text-stroke:1px rgba(200,112,144,0.10);
          white-space:nowrap;
          pointer-events:none;
        }
        .na-hero-eyebrow{
          font-size:9px;font-weight:500;letter-spacing:.26em;
          text-transform:uppercase;color:#c87090;
          margin-bottom:8px;display:block;position:relative;z-index:1;
        }
        .na-hero-title{
          font-family:'Cormorant Garamond',serif;
          font-size:clamp(24px,4vw,40px);
          font-weight:300;color:#fdf9f6;
          letter-spacing:-.01em;display:block;
          position:relative;z-index:1;
          margin-bottom:6px;
        }
        .na-hero-sub{
          font-size:12px;font-weight:300;
          color:rgba(253,249,246,0.5);
          display:block;position:relative;z-index:1;
        }

        /* ── BODY ── */
        .na-body{
          max-width:1120px;
          margin:0 auto;
          padding: 32px 32px 56px;
        }
        @media(max-width:768px){.na-body{padding:24px 16px 40px}}

        /* ── GRID ── */
        .na-grid{
          display:grid;
          grid-template-columns:repeat(4,1fr);
          gap:12px;
        }
        @media(max-width:900px){.na-grid{grid-template-columns:repeat(2,1fr);gap:10px}}
        @media(max-width:480px){.na-grid{grid-template-columns:repeat(2,1fr);gap:8px}}

        /* ── EMPTY ── */
        .na-empty{
          grid-column:1/-1;
          text-align:center;
          padding:48px 20px;
        }
        .na-empty-title{
          font-family:'Cormorant Garamond',serif;
          font-size:22px;font-weight:300;color:#1a1410;
          margin-bottom:8px;display:block;
        }
        .na-empty-sub{
          font-size:13px;font-weight:300;color:#a09890;
          margin-bottom:20px;display:block;
        }
        .na-shop-btn{
          display:inline-block;
          background:#1a1410;color:#fdf9f6;
          font-size:10px;font-weight:500;
          letter-spacing:.16em;text-transform:uppercase;
          text-decoration:none;
          padding:10px 24px;
          transition:background .2s;
        }
        .na-shop-btn:hover{background:#c87090}

        /* ── SKELETON ── */
        .na-skel{background:#fff;border:1px solid #ede8e2;overflow:hidden}
        .na-sk-img{
          height:160px;
          background:linear-gradient(90deg,#f4f0ec 25%,#ede8e2 50%,#f4f0ec 75%);
          background-size:200% 100%;
          animation:na-shimmer 1.4s infinite;
        }
        .na-sk-b{padding:10px 12px}
        .na-sk-l{
          height:9px;
          background:linear-gradient(90deg,#f4f0ec 25%,#ede8e2 50%,#f4f0ec 75%);
          background-size:200% 100%;
          animation:na-shimmer 1.4s infinite;
          margin-bottom:7px;
          border-radius:3px;
        }
        .na-sk-l.s{width:55%}
        @keyframes na-shimmer{from{background-position:200% 0}to{background-position:-200% 0}}
      `}</style>

      <div className="na-root">
        <div className="na-hero">
          <span className="na-hero-eyebrow">Just Landed</span>
          <span className="na-hero-title">New Arrivals</span>
          <span className="na-hero-sub">Fresh styles added to our collection</span>
        </div>

        <div className="na-body">
          <div className="na-grid">
            {loading
              ? [1,2,3,4,5,6,7,8].map(i => (
                  <div key={i} className="na-skel">
                    <div className="na-sk-img"/>
                    <div className="na-sk-b">
                      <div className="na-sk-l s"/><div className="na-sk-l"/><div className="na-sk-l s"/>
                    </div>
                  </div>
                ))
              : products.length === 0
              ? (
                <div className="na-empty">
                  <span className="na-empty-title">No new arrivals yet</span>
                  <span className="na-empty-sub">Check back soon — new styles are on the way.</span>
                  <Link to="/products" className="na-shop-btn">Browse All Products</Link>
                </div>
              )
              : products.map(p => <ProductCard key={p._id} product={p} />)
            }
          </div>
        </div>
      </div>
    </>
  );
}